import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment-timezone';
import { Map } from 'immutable';
import cn from 'classnames';
import { AiOutlineCalendar } from 'react-icons/ai';

const propTypes = {
  event: PropTypes.instanceOf(Map).isRequired,
  settings: PropTypes.instanceOf(Map).isRequired,
  format: PropTypes.string,
  className: PropTypes.string,
  withIcon: PropTypes.bool,
};

function Time({ event, settings, format, className = '', withIcon }) {
  const startTime = event.getIn(['date', 'start', 'utc']);
  const endTime = event.getIn(['date', 'end', 'utc']);
  const timeZone = event.getIn(['date', 'start', 'timezone']);

  let momentStartTime = moment(event.getIn(['date', 'start']));
  let momentEndTime = moment(event.getIn(['date', 'start']));
  if (startTime) {
    momentStartTime = moment(startTime).tz(timeZone);
    momentEndTime = moment(endTime).tz(timeZone);
  }

  const momentStartLocale = momentStartTime.locale(event.get('locale', 'en'));
  const momentEndLocale = momentEndTime.locale(event.get('locale', 'en'));

  const date = settings.get('showEndDate', false) ? (
    <EndTimeDisplay
      momentStartLocale={momentStartLocale}
      momentEndLocale={momentEndLocale}
      format={format || 'll'}
    />
  ) : (
    <span>{momentStartLocale.format(format || 'llll')}</span>
  );

  const time = settings.get('showEndDate', false) ? (
    <EndTimeDisplay
      momentStartLocale={momentStartLocale}
      momentEndLocale={momentEndLocale}
      format="LT"
    />
  ) : (
    ''
  );
  const isMobile = Wix.Utils.getDeviceType() === 'mobile';

  const direction = isMobile ? { 'flex-direction': 'column' } : {};
  if (withIcon) {
    return (
      <div style={{ display: 'flex', alignItems: 'center' }}>
        <AiOutlineCalendar size={25} style={{ marginRight: 5 }} />
        <div className={cn('date', className)}>
          <div style={{ display: 'flex' }}>
            {date} {event.get('isRecurring') && <span style={{ marginLeft: 5 }}>(Recurring)</span>}
          </div>
          {time && <div style={{ display: 'flex', marginTop: 10 }}>{time}</div>}
        </div>
      </div>
    );
  }
  return (
    <div className={cn('date', className)}>
      <div style={{ display: 'flex', ...direction, justifyContent: 'center' }}>
        {date} {event.get('isRecurring') && <span style={{ marginLeft: 5 }}>(Recurring)</span>}
      </div>
      <div style={{ display: 'flex', marginTop: 10, justifyContent: 'center' }}>{time}</div>
    </div>
  );
}

function EndTimeDisplay({ momentStartLocale, momentEndLocale, format }) {
  return (
    <div style={{ display: 'inline-flex' }}>
      <span>{momentStartLocale.format(format)}</span> <span style={{ margin: '0 5px' }}>-</span>
      <span>{momentEndLocale.format(format)}</span>
    </div>
  );
}
Time.propTypes = propTypes;

export default Time;



// WEBPACK FOOTER //
// ./src/widget/event_components/time.js